export const reportSelections = [
    { name: "Batch History", link: "/merchant/reports/batch", type: "Merchants" },
    // { name: "Deposit History", link: "/merchant/reports/deposits", type: "Merchants" },
    { name: "Sales by Merchant", link: "/admin/reports/sales-by-merchant", type: "Admin" }
]